exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-bdb7348c]:disabled {\n  opacity: 0.7 !important;\n  border-color: rgba(118, 118, 118, 0.3);\n}", ""]);

// exports
